import React from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';

import Header from './components/Header';
import Drawer from './components/Drawer';

import { Container, Content } from './styles';

function SignedLayout({ children }) {
  return (
    <Container>
      <CssBaseline />
      <Header />
      <Drawer />

      <Content>
        <Toolbar />
        {children}
      </Content>
    </Container>
  );
}

SignedLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SignedLayout;
